<template>
  <div class="app-container">
    <list ref="list" :can-price="$permission.canPrice()">
        <template slot="toolbar-right" v-if="$permission.canWrite()">
            <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button>
        </template>
        <template slot="column">
            <el-table-column label="操作" fixed="right" align="center" width="100">
                <template slot-scope="{row}">
                    <el-button v-if="$permission.canWrite() && row.Status !== 2" @click="edit(row)" type="text" >
                      编辑
                    </el-button>
                    <el-button v-if="$permission.canReview() && row.Status == 2"   type="text" @click="edit(row)">查看</el-button>
                       <el-button type="text" @click="onPrint(row)">打印</el-button>
                </template>
            </el-table-column>
      </template>
    </list>
    <!-- <edit-dialog ref="editDialog"></edit-dialog> -->
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from '@/components/demo/sumables/list'


export default {
  name: "bom",
  mixins: [curdMixins],
  components: {
    list,
  },
 data(){
    return {
      api: require("@/api/pr/prUseDoc").default,
    }
  },
  methods: {
    edit({DocId}){
      let id = DocId;
      this.api.info(id).then(res => {
        if(res.Code === 0){
          this.toURL({
            name: 'editsumables',
            params: {
              type: 'edit',
              data: res.Data
            }
          })
        }else{
          this.$message({
            type: 'warning',
            message: res.Msg
          })
        }
        

      })
    },
    create(){
      
      this.toURL({
        name: 'editsumables',
        params: {
          type: 'create'
        }
      })

    },
     onPrint(row) {
      let newpage = this.$router.resolve({
        path: "/productionconsumablesPrint?id=" + row.DocId,
      });
      window.open(newpage.href, "_blank");
    },
    toURL(o){
      this.$router.push(o)
    }
  }
};
</script>